import { api } from '../utils/apiClient';

export const eventsService = {
  // { total, unique_users, daily: [{day, count}], top_events: [{name, count}] }
  // (only present when no event_name filter) — backs the Events page's KPI
  // cards, volume chart, and top-events breakdown.
  async stats({ from, to, event_name, property_key, property_value } = {}) {
    return api.get('/events/stats', { from, to, event_name, property_key, property_value });
  },

  // Raw, filterable event log — real per-row `properties`, not aggregated.
  async log({ from, to, event_name, user_id, property_key, property_value, page, limit } = {}) {
    return api.getWithMeta('/events/log', { from, to, event_name, user_id, property_key, property_value, page, limit });
  },
};
